import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { OrgTypes } from '@mode/shared/contract-common';
import { SplitValuePipe } from '@mode/shared/ui';
import { ColorPaletteSelectorComponent } from '../color-palette-selector/color-palette-selector.component';

@Component({
  standalone: true,
  imports: [CommonModule, SplitValuePipe, ColorPaletteSelectorComponent],
  selector: 'mode-color-swatch-selector',
  templateUrl: './color-swatch-selector.component.html',
  styleUrls: ['./color-swatch-selector.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ColorSwatchSelectorComponent {
  @Input() selectedColorPalette: OrgTypes.ColorPalette | undefined = undefined;
  @Input() allColorPalettes: OrgTypes.ColorPalette[] = [];
  @Input() activeColor = '';
  @Output() swatchClicked = new EventEmitter<{ colorSelected: string; selectedPalette: OrgTypes.ColorPalette }>();
  @Output() paletteChanged = new EventEmitter<OrgTypes.ColorPalette>();

  onPaletteChanged(palette: OrgTypes.ColorPalette) {
    this.selectedColorPalette = palette;
    this.paletteChanged.emit(palette);
  }

  onSwatchClick(selectedColor: string) {
    if (selectedColor.trim() !== this.activeColor?.trim()) {
      this.activeColor = selectedColor.trim();

      if (this.selectedColorPalette) {
        this.swatchClicked.emit({ colorSelected: this.activeColor, selectedPalette: this.selectedColorPalette });
      }
    }
  }

  isSelected(color: string) {
    if (this.activeColor === color.trim()) {
      return true;
    } else {
      return false;
    }
  }
}
